import React from "react";

const Title = ({ children }) => {
  return (
    <h2>
      <span>{children}</span>
    </h2>
  );
};

export default Title;
